<template>
  <b-row>
    <b-col class="text-center">
      <b-btn
        v-if="betaUrl"
        id="beta-url-link"
        size="sm"
        variant="link"
        target="_blank"
        :href="betaUrl">
        <i class="fas fa-external-link-alt fa-sm" />
        {{ betaEnvName }} {{ configLabel }}
      </b-btn>
      <b-icon-clock-history
        v-if="betaLastModifiedText"
        v-b-tooltip.hover="betaLastModifiedText"
        variant="primary" />
    </b-col>
    <b-col class="text-center">
      <b-btn
        v-if="prodUrl"
        id="prod-url-link"
        size="sm"
        variant="link"
        target="_blank"
        :href="prodUrl">
        <i class="fas fa-external-link-alt fa-sm" />
        {{ liveEnvName }} {{ configLabel }}
      </b-btn>
      <b-icon-clock-history
        v-if="prodLastModifiedText"
        v-b-tooltip.hover="prodLastModifiedText"
        variant="primary" />
    </b-col>
    <b-col cols="1" />
  </b-row>
</template>

<script>
import {mapGetters} from "vuex"
import {DateTime} from "luxon"

export default {
  name: "ConfigLinks",
  props: {
    betaUrl: {
      type: String,
      default: "",
    },
    prodUrl: {
      type: String,
      default: "",
    },
    betaLastModifiedBy: {
      type: String,
      default: "",
    },
    betaLastModifiedOn: {
      validator: it => it === null || DateTime.isDateTime(it),
      default: null,
    },
    prodLastModifiedBy: {
      type: String,
      default: "",
    },
    prodLastModifiedOn: {
      validator: it => it === null || DateTime.isDateTime(it),
      default: null,
    },
    configLabel: {
      type: String,
      default: "Config",
    },
  },
  computed: {
    ...mapGetters([
      "betaEnvName",
      "liveEnvName",
    ]),
    betaLastModifiedText() {
      return this.buildModifiedText(this.betaLastModifiedBy, this.betaLastModifiedOn)
    },
    prodLastModifiedText() {
      return this.buildModifiedText(this.prodLastModifiedBy, this.prodLastModifiedOn)
    },
  },
  methods: {
    buildModifiedText(modifiedBy, modifiedOn) {
      if (!modifiedOn && !modifiedBy) {
        return ""
      }

      let text = "Last modified"
      if (modifiedBy) {
        text += ` by ${modifiedBy}`
      }
      if (modifiedOn) {
        text += ` on ${modifiedOn.toLocaleString(DateTime.DATETIME_FULL)}`
      }
      return text
    },
  },
}
</script>

<style scoped>

</style>
